import React, { useEffect } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCheck, faSync } from "@fortawesome/free-solid-svg-icons"
import * as Addons from "./Addons"
// Assurances
export const ASSURANCE_POLICE_ID = 2

// Lieu d'intervention police (GE-7) : enum EN DUR, source unique côté front
// (miroir de LIEU_POLICE_* dans backend/svp/constants.py). Ne pas renuméroter.
export const SECTEURS_POLICE = {
	1: "Autoroute",
	2: "Sous-sol",
	3: "Police Municipale",
	4: "Route",
}

export const VEHICULE_CATEGORIE = {
	1: "Voiture",
	2: "Poids lourd",
	3: "Moto / Scooter",
	4: "Vélo / Vélomoteur",
}
// Ordre d'affichage des listes (même ordre que SvpMobile, décision Jordan
// 01.10) — affichage seul : les clés ci-dessus (miroir svp/constants.py,
// tarifs police) ne se renumérotent pas.
export const VEHICULE_CATEGORIE_ORDRE = [1, 3, 4, 2]

export const getTotalHTFromAL = (aL, tva) => {
	let totalHT = aL.quantite * aL.prixVente
	if (!aL.isHT) totalHT = Addons.TTCtoHT(totalHT, tva)
	if (aL.rabaisIsFlat) totalHT -= aL.rabais
	else totalHT -= (totalHT * aL.rabais) / 100
	return totalHT
}

export const SavingButton = ({
	classes,
	onclick,
	saving,
	saved,
	callback,
	name,
	disabled,
}) => {
	useEffect(() => {
		if (saved && callback) setTimeout(callback, 500)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [saved])
	return (
		<button
			type="button"
			className={classes ? `btn norm-btn2 ${classes}` : "btn norm-btn2"}
			onClick={onclick}
			disabled={disabled ? disabled : saving || saved}
		>
			{saving ? (
				<FontAwesomeIcon icon={faSync} spin />
			) : saved ? (
				<FontAwesomeIcon icon={faCheck} />
			) : name ? (
				name
			) : (
				"Sauvegarder"
			)}
		</button>
	)
}

export const DefaultSpinner = () => {
	return (
		<div className={"default-spinner"}>
			<FontAwesomeIcon icon={faSync} spin size={"lg"} />
		</div>
	)
}
